import React, { Component } from "react";
import {Link} from "react-router-dom";


import gallery1Img from "../../../assets/images/gallary/EngineeringJobs/Brass Screw Conveyor.jpg"
import gallery2Img from "../../../assets/images/gallary/EngineeringJobs/Chilled Water Pipeline work.jpeg"
import gallery3Img from "../../../assets/images/gallary/EngineeringJobs/Cooling Tower Pipeline works.jpg"
import gallery4Img from "../../../assets/images/gallary/EngineeringJobs/Gas Welding.jpg"
import gallery5Img from "../../../assets/images/gallary/EngineeringJobs/Heavy Duty Platfroms.jpg"
import gallery6Img from "../../../assets/images/gallary/EngineeringJobs/Industrial Vice with Trolley.jpg"

import gallery7Img from "../../../assets/images/gallary/EngineeringJobs/Press Machine.jpg"
import gallery8Img from "../../../assets/images/gallary/EngineeringJobs/Rotating Table (1).jpg"
import gallery9Img from "../../../assets/images/gallary/EngineeringJobs/Rotating Table (2).jpg"
import gallery10Img from "../../../assets/images/gallary/EngineeringJobs/Carrier Stand (2).jpg"
import gallery11Img from "../../../assets/images/gallary/EngineeringJobs/Man Basket.jpg"

import gallery12Img from "../../../assets/images/gallary/EngineeringJobs/Paint Mixer.jpg"
import gallery13Img from "../../../assets/images/gallary/EngineeringJobs/Pipe Threading (2).jpg"
import gallery14Img from "../../../assets/images/gallary/EngineeringJobs/Pipe Threading.jpg"
import gallery15Img from "../../../assets/images/gallary/EngineeringJobs/Pipe Welding.jpg"
import gallery16Img from "../../../assets/images/gallary/EngineeringJobs/Pipeline work.jpg"
import gallery17Img from "../../../assets/images/gallary/EngineeringJobs/Revolving Table.jpg"
import gallery18Img from "../../../assets/images/gallary/EngineeringJobs/Stainless Steel Pipe Line work.jpg"
import gallery19Img from "../../../assets/images/gallary/EngineeringJobs/unnamed.jpg"
import gallery20Img from "../../../assets/images/gallary/EngineeringJobs/Vice with Trolley2.jpg"


import { SRLWrapper } from "simple-react-lightbox";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class Product4 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:new Date(),
        };
    }
    changeDatepickerHandeller=(date)=>{
        this.setState({ startDate: date });
    }

    componentDidMount(){
        this.scrollTop();
    }

    scrollTop()
    {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
  render() {
        const startDate =this.state.startDate;

    return (
        <>
            {/* ===============  breadcrumb area start =============== */}
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="breadcrumb-wrap">
                                <h2>Engineering Jobs</h2>
                                <ul className="breadcrumb-links">
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}/`}>Home</Link>
                                        <i className="bx bx-chevron-right" />
                                    </li>
                                    <li>Engineering Jobs</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ===============  breadcrumb area end =============== */}
            <div className="package-details-wrapper pt-20">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="package-details">

                                <div className="package-tab">



                                    <div className="tab-content p-tab-content" id="pills-tabContent">
                                        <div className="tab-pane fade show active" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                                            <div className="tab-contant-3">
                                                <SRLWrapper>
                                                <div className="row">

                                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <h4>Engineering Jobs</h4>
                                                             <Link to={gallery1Img} >
                                                                    <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery1Img} alt="gallary-img" />
                                                                </Link>



                                                                      <Link to={gallery4Img} >
                                                                             <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery4Img} alt="gallary-img" />
                                                                         </Link>

                                                                         <Link to={gallery5Img} >
                                                                                <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery5Img} alt="gallary-img" />
                                                                            </Link>

                                                                            <Link to={gallery6Img} >
                                                                                   <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery6Img} alt="gallary-img" />
                                                                               </Link>


                                                                               <Link to={gallery7Img} >
                                                                                      <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery7Img} alt="gallary-img" />
                                                                                  </Link>
                                                                                  <Link to={gallery8Img} >
                                                                                         <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery8Img} alt="gallary-img" />
                                                                                     </Link>
                                                                                     <Link to={gallery9Img} >
                                                                                            <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery9Img} alt="gallary-img" />
                                                                                        </Link>
                                                                                        <Link to={gallery10Img} >
                                                                                               <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery10Img} alt="gallary-img" />
                                                                                           </Link>
                                                                                           <Link to={gallery11Img} >
                                                                                                  <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery11Img} alt="gallary-img" />
                                                                                              </Link>









                                                                                                             <Link to={gallery17Img} >
                                                                                                                    <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery17Img} alt="gallary-img" />
                                                                                                                </Link>

                                                                                                                <Link to={gallery18Img} >
                                                                                                                       <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery18Img} alt="gallary-img" />
                                                                                                                   </Link>



                                                                                                                      <Link to={gallery20Img} >
                                                                                                                             <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery20Img} alt="gallary-img" />
                                                                                                                         </Link>

                                                                                                                                               </div>

                                                                                                                                               <div className="col-lg-12 col-md-12 col-sm-12">
                                                                                                                                               <h4 style={{marginTop:50}}>Mixer Machines</h4>

                                                                                                                                               <Link to={gallery7Img} >
                                                                                                                                                      <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery7Img} alt="gallary-img" />
                                                                                                                                                  </Link>

                                                                                                                                                  <Link to={gallery11Img} >
                                                                                                                                                         <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery11Img} alt="gallary-img" />
                                                                                                                                                     </Link>

                                                                                                                                                     <Link to={gallery12Img} >
                                                                                                                                                            <img width="150" height="150" style={{marginRight:10, marginTop:10}} src={gallery12Img} alt="gallary-img" />
                                                                                                                                                        </Link>

                                                                                                                                               </div>

                                                                                                                                           </div>
                                                                                                                                           </SRLWrapper><br/>
                                                                                                                                       </div>
                                                                                                                                   </div>
                                                                                                                               </div>
                                                                                                                           </div>
                                                                                                                       </div>
                                                                                                                   </div>

                                                                                                               </div>
                                                                                                           </div>
                                                                                                       </div>
                                                                                                   </>
                                                                                               );
                                                                                             }
                                                                                           }

   export default Product4;
